export default __webpack_public_path__ + "static/media/Sucessfull.37567210.svg";